import ReservationBoxItem from "./ReservationBoxItem";

type Props = {
  timeSlotsTime: string;
  facility: any;
  currentPage: number;
  handleReservationDetailModal: (type: string, payload?: any) => void;
  getCurrentTimePosition: number;
  selectedDate: Date;
};

const ReservationBox = ({ handleReservationDetailModal, facility, timeSlotsTime, getCurrentTimePosition, currentPage, selectedDate }: Props) => {
  if (facility?.reservations) {
    return facility.reservations.map((reservation: any) => (
      <ReservationBoxItem
        key={reservation.id}
        reservation={reservation}
        facility={facility}
        handleReservationDetailModal={handleReservationDetailModal}
        getCurrentTimePosition={getCurrentTimePosition}
        currentPage={currentPage}
        timeSlotsTime={timeSlotsTime}
        selectedDate={selectedDate}
      />
    ));
  }

  return null;
};

export default ReservationBox;
